import {
	IListAttrs,
	IListColumnConfig,
	IListOperations,
} from '@datachain/ui-sdk/common';
import { produce, immerable } from 'immer';
import { Map, Set } from 'immutable';

import { GridItemEntity } from './grid-item.entity';

export interface IGridListExtra extends IListColumnConfig<GridItemEntity> {
	width?: string | number;
	filterValue?: Array<string | number>;
	filterValues?: Array<string | number>;
	sortIndex?: number;
	sortOrder?: 'asc' | 'desc';
}

interface IGridListEntity extends IListAttrs<GridItemEntity> {
	availableColumns: Map<string, IGridListExtra>;
}

const entityDefaults: IGridListEntity = {
	elements: Map(),
	availableColumns: Map(),
};

export class GridListEntity
	implements IGridListEntity, IListOperations<GridListEntity, GridItemEntity>
{
	private [immerable] = true;
	public elements = entityDefaults.elements;
	public availableColumns = entityDefaults.availableColumns;

	public static build(availableCols: Array<IGridListExtra>): GridListEntity {
		const instance = new GridListEntity();
		const cols = availableCols.reduce((acc, curr) => {
			acc.push([curr.field, curr]);
			return acc;
		}, new Array<[string, IGridListExtra]>());

		instance.availableColumns = Map(cols);
		return instance;
	}

	private constructor() {}

	public getAvailableColumns(): Map<string, IListColumnConfig<GridItemEntity>> {
		return this.availableColumns;
	}

	public setElements(elems: Map<string, GridItemEntity>): GridListEntity {
		return produce(this, (draft: GridListEntity) => {
			draft.elements = elems;
		});
	}

	public extractUniqTags(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, gridItem) => {
			if (!gridItem.tags) {
				return acc;
			}
			return Set([
				...acc.toArray(),
				...gridItem.tags
					.toList()
					.toArray()
					.map((l) => l.label),
			]);
		}, Set<string>(startValues));
	}

	public extractModifiers(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, entityItem) => {
			if (entityItem.updatedByAvatar && entityItem.updatedByAvatar?.name) {
				acc = acc.add(entityItem.updatedByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}

	public extractActionCreators(...startValues: Array<string>): Set<string> {
		return this.elements.reduce((acc, entityItem) => {
			if (entityItem.createdByAvatar && entityItem.createdByAvatar.name) {
				acc = acc.add(entityItem.createdByAvatar.name);
			}
			return acc;
		}, Set<string>(startValues));
	}
}
